import axios from 'axios';
import type { WorkflowResponse } from '../types/mindstudio';

const mindstudioApi = axios.create({
  baseURL: import.meta.env.VITE_MINDSTUDIO_API_URL,
  headers: {
    'Authorization': `Bearer ${import.meta.env.VITE_MINDSTUDIO_BEARER_TOKEN}`,
    'Content-Type': 'application/json'
  }
});

export const executeWorkflow = async <T = any>(
  appId: string,
  variables: Record<string, any>,
  metadata?: {
    userId?: string;
    sessionId?: string;
    tags?: string[];
  }
): Promise<WorkflowResponse<T>> => {
  try {
    const response = await mindstudioApi.post('/developer/v2/workers/run', {
      appId,
      variables,
      metadata,
      includeBillingCosts: true
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Failed to execute workflow');
    }
    throw error;
  }
};

export const getUsage = async (params: {
  from: string;
  to: string;
  appId?: string;
}) => {
  try {
    const response = await mindstudioApi.post('/developer/v2/apps/usage', params);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Failed to fetch usage data');
    }
    throw error;
  }
};